import React from 'react';
import Iconify from 'src/components/Iconify';
import AcompanhamentoPanel from './AcompanhamentoPanel';

// Drawer lateral aberto pelo card do kanban / linha da lista. O conteúdo é o
// mesmo componente usado dentro do editor da proposta.
export default function AcompanhamentoDrawer({ proposta, onClose }) {
  if (!proposta) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex justify-end">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-[2px] animate-in fade-in duration-200"
        onClick={onClose}
      />

      <div className="relative w-full max-w-md h-full bg-gray-50 dark:bg-[#1A1D21] shadow-2xl flex flex-col animate-in slide-in-from-right duration-300">
        <div className="flex items-center gap-3 px-5 py-4 border-b border-gray-100 dark:border-[#383838] bg-white dark:bg-[#222529] flex-shrink-0">
          <div className="w-9 h-9 rounded-xl bg-violet-50 dark:bg-violet-500/10 flex items-center justify-center flex-shrink-0">
            <Iconify icon="mdi:chart-timeline-variant" width={18} className="text-[#7C3AED]" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-bold text-gray-900 dark:text-[#D1D2D3] truncate">Acompanhamento</p>
            <p className="text-xs text-gray-500 dark:text-[#ABABAD] truncate">{proposta.titulo}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100 dark:hover:bg-[#383838] hover:text-gray-600 dark:hover:text-[#D1D2D3] transition-colors flex-shrink-0"
          >
            <Iconify icon="eva:close-outline" width={18} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <AcompanhamentoPanel propostaId={proposta._id} />
        </div>
      </div>
    </div>
  );
}
